export class Constant{
  public static readonly LOGGED_IN_USER:string = 'LOGGED_IN_USER';
  public static readonly USER_DATA:string = 'USER_DATA';
  public static readonly LOCAL_GOVERNMENT_LIST:string = 'LOCAL_GOVERNMENT_LIST';
  public static readonly TEMP_LOGGED_IN_USER:string = 'TEMP_LOGGED_IN_USER';

}
